<template>
  <a-layout-header :class="[theme, 'global-header']">
    <div :class="['global-header-wide', layout]">
      <router-link v-if="isMobile || layout === 'head'" to="/" :class="['logo', isMobile ? null : 'pc', theme]">
        <img width="32" src="static/img/vue-antd-logo.png" />
        <h1 v-if="!isMobile">{{systemName}}</h1>
      </router-link>
      <a-divider v-if="isMobile" type="vertical" />
<!--      折叠菜单-->
      <a-icon v-if="layout === 'side'" class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="toggleCollapse"/>
      <div v-if="layout === 'head'" class="global-header-menu">
        <i-menu style="height: 64px; line-height: 64px;" :theme="theme" mode="horizontal" :menuData="menuData" @select="onSelect"/>
      </div>
      <header-avatar style="float: right" class="header-item"/>
      <div class="userClass">
        <el-row>
          <el-col :span="12" style="cursor: pointer">
            <div v-if="authTenantData.length === 1">
              <div class="textStyle">
                  <i class="el-icon-s-custom"></i>
                 <span>{{ loginTenant.tenantName }}</span>
              </div>
            </div>
            <!--      可选租户-->
            <div v-else v-show="authTenantData.length > 1">
              <el-dropdown trigger="click" @command="handleAuthTenant">
                <div class="textStyle">
                  <i class="el-icon-s-custom"></i>
                  <span>{{ loginTenant.tenantName }}</span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </div>
                <el-dropdown-menu slot="dropdown" style="max-height: 500px; overflow: auto">
                  <el-dropdown-item
                    v-for="item in authTenantData"
                    :key="item.tenantId"
                    :command="item.tenantId"
                    :disabled="loginTenant.tenantId === item.tenantId"
                    divided>
                   {{ item.tenantName }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-col>
          <el-col :span="12" style="cursor: pointer">
            <div v-if="authDepartmentData.length === 1">
              <div class="textStyle">
                  <i class="el-icon-s-grid"></i>
                 <span>{{ loginDepartment.departmentName }}</span>
              </div>
            </div>
            <!--可选部门-->
            <div v-else v-show="authDepartmentData.length > 1">
              <el-dropdown trigger="click" @command="handleAuthDepartment">
              <div class="textStyle">
                  <i class="el-icon-s-grid"></i>
                <span>{{ loginDepartment.departmentName }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </div>
                <el-dropdown-menu slot="dropdown" style="max-height: 500px; overflow: auto">
                  <el-dropdown-item
                    v-for="item in authDepartmentData"
                    :key="item.departmentId"
                    :command="item.departmentId"
                    :disabled="item.departmentId === loginDepartment.departmentId"
                    divided>
                    {{ item.departmentName }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </a-layout-header>
</template>

<script>
import HeaderSearch from './HeaderSearch'
import HeaderNotice from './HeaderNotice'
import HeaderAvatar from './HeaderlAvatar'
import IMenu from '../components/menu/menu'
import { switchLoginTenant, switchLoginDepartment } from '@/api/login'
export default {
  name: 'GlobalHeader',
  components: {IMenu, HeaderAvatar, HeaderNotice, HeaderSearch},
  props: ['collapsed', 'menuData'],
  computed: {
    isMobile () {
      return this.$store.state.setting.isMobile
    },
    layout () {
      return this.$store.state.setting.layout
    },
    theme () {
      return this.layout === 'side' ? 'light' : this.$store.state.setting.theme
    },
    systemName () {
      return this.$store.state.setting.systemName
    },
    authTenantData () {
      return this.$store.state.user.authTenants
    },
    authDepartmentData () {
      return this.$store.state.user.authDepartments
    },
    loginTenant () {
      return this.$store.state.user.currentLoginTenant
    },
    loginDepartment () {
      return this.$store.state.user.currentLoginDepartment
    }
  },
  data () {
    return {}
  },
  created () {},
  methods: {
    handleAuthTenant (tenantId) {
      switchLoginTenant(tenantId).then(res => {
        location.reload()
      })
    },
    handleAuthDepartment (departmentId) {
      switchLoginDepartment(departmentId).then(res => {
        location.reload()
      })
    },
    toggleCollapse () {
      this.$emit('toggleCollapse')
    },
    onSelect (obj) {
      this.$emit('menuSelect', obj)
    }
  }
}
</script>
<style lang="less" scoped>
  .trigger {
    font-size: 20px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color .3s;
    &:hover{
      color: #1890ff;
    }
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .header-item{
    padding: 0 12px;
    display: inline-block;
    height: 100%;
    cursor: pointer;
    vertical-align: middle;
    i{
      font-size: 16px;
      color: rgba(0,0,0,.65);
    }
  }
  .global-header{
    padding: 0 12px 0 0;
    -webkit-box-shadow: 0 1px 4px rgba(0,21,41,.08);
    box-shadow: 0 1px 4px rgba(0,21,41,.08);
    position: relative;
    &.light{
      background: #fff;
    }
    &.dark{
      background: #001529;
    }
    .global-header-wide{
      &.head{
        max-width: 1400px;
        margin: auto;
      }
      &.side{
      }
      .userClass {
        float: right;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        width: 400px;
        .textStyle {
          overflow: hidden;
          text-overflow:ellipsis;
          width: 160px;
          white-space: nowrap;
        }
      }
      .logo {
        height: 64px;
        line-height: 58px;
        vertical-align: top;
        display: inline-block;
        padding: 0 12px 0 24px;
        cursor: pointer;
        font-size: 20px;
        &.pc{
          padding: 0 12px 0 0;
        }
        img {
          display: inline-block;
          vertical-align: middle;
        }
        h1{
          display: inline-block;
          font-size: 16px;
        }
        &.dark h1{
          color: #fff;
        }
      }
      .global-header-menu{
        display: inline-block;
      }
      .global-header-right{
        float: right;
        &.dark{
          color: #fff;
          i{
            color: #fff;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layouts/GlobalHeader.vue